// API Configuration
// Automatically detect environment based on current domain
const isLocalDevelopment = window.location.hostname === 'localhost' || 
                          window.location.hostname === '127.0.0.1' || 
                          window.location.hostname.includes('localhost');

export const API_BASE_URL = isLocalDevelopment 
  ? 'http://127.0.0.1:8000/api'
  : 'https://api.msqindex.com/api';
// Auth endpoints
export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const REFRESH_TOKEN = '/refresh-token';

// Survey endpoints
export const SURVEYS = '/surveys';
export const SURVEY_DETAILS = '/surveys/{id}';
export const SURVEY_RESPONSES = '/surveys/{id}/responses';

// Public Survey endpoints
export const PUBLIC_SURVEYS = '/public/surveys';

// User endpoints
export const USERS = '/users';
export const USER_DETAILS = '/users/{id}';
export const USER_STATUS = '/users/{id}/status';
export const USER_STATS = '/users/stats';

// Site endpoints
export const SITES = '/sites';
export const SITE_DETAILS = '/sites/{id}';
export const SITE_STATUS = '/sites/{id}/status';
export const SITE_STATS = '/sites/stats';

// Public Site endpoints
export const PUBLIC_SITES = '/public/sites';

// Public Email endpoints
export const PUBLIC_SEND_MAIL = '/public/send-mail-by-session';
export const PUBLIC_SEND_MAIL_BY_INVITE = '/public/send-mail-by-invite';
export const SEND_MAIL = '/send-mail';

// Access Code endpoints
export const ACCESS_CODES = '/access-codes';
export const ACCESS_CODE_DETAILS = '/access-codes/{id}';
export const ACCESS_CODE_STATUS = '/access-codes/{id}/status';
export const ACCESS_CODE_STATS = '/access-codes/stats';

// Public Access Code endpoints
export const PUBLIC_ACCESS_CODE_VALIDATE = '/public/access-codes/validate/{access_code}';

// MSQ Accreditation endpoints
export const MSQ_ACCREDITATIONS = '/msq-accreditations';
export const MSQ_ACCREDITATION_DETAILS = '/msq-accreditation/{id}';
export const MSQ_ACCREDITATION_STATUS = '/msq-accreditations/{id}/status';
export const MSQ_ACCREDITATION_STATS = '/msq-accreditations/stats';

// MSQ Case Studies endpoints
export const MSQ_CASE_STUDIES = '/msq-case-studies';
export const MSQ_CASE_STUDY_DETAILS = '/msq-case-studies/{id}';
export const MSQ_CASE_STUDY_STATUS = '/msq-case-studies/{id}/status';
export const MSQ_CASE_STUDY_STATS = '/msq-case-studies/stats';

// Academy endpoints
export const ACADEMY = '/academy';
export const ACADEMY_DETAILS = '/academy/{id}';
export const ACADEMY_STATUS = '/academy/{id}/status';
export const ACADEMY_STATS = '/academy/stats';

// PDF Content endpoints
export const PDF_CONTENT = '/pdf-contents';
export const PDF_CONTENT_SITE = '/pdf-contents/site/{site_id}';
export const PDF_CONTENT_DETAILS = '/pdf-contents/{id}';
export const PDF_CONTENT_STATUS = '/pdf-contents/{id}/status';
export const PDF_CONTENT_STATS = '/pdf-contents/stats';

// Invite List endpoints
export const INVITE_LIST = '/invite-lists';
export const INVITE_LIST_DETAILS = '/invite-lists/{id}';
export const INVITE_LIST_STATUS = '/invite-lists/{id}/status';
export const INVITE_LIST_STATS = '/invite-lists/stats';
export const INVITE_LIST_SEND_EMAIL = '/invite-lists/{id}/send-email';

// Invite Content endpoints
export const INVITE_CONTENT = '/invite-contents';
export const INVITE_CONTENT_DETAILS = '/invite-contents/{id}';
export const INVITE_CONTENT_STATUS = '/invite-contents/{id}/status';
export const INVITE_CONTENT_STATS = '/invite-contents/stats';

// Dashboard Content endpoints
export const DASHBOARD_CONTENT = '/dashboard-contents';
export const DASHBOARD_CONTENT_DETAILS = '/dashboard-contents/{id}';

// Site Meta endpoints
export const SITE_META = '/site-meta';
export const SITE_META_DETAILS = '/site-meta/{site_id}';

// Confirmation Page endpoints
export const CONFIRMATION_PAGE = '/confirmation-contents';
export const CONFIRMATION_PAGE_DETAILS = '/confirmation-contents/{id}';
export const CONFIRMATION_PAGE_STATUS = '/confirmation-contents/{id}/status';
export const CONFIRMATION_PAGE_STATS = '/confirmation-contents/stats';

// Public Confirmation Page endpoints
export const PUBLIC_CONFIRMATION_PAGE = '/public/confirmation-contents/{site_id}';

// Email Templates endpoints
export const EMAIL_TEMPLATES = '/email-template';
export const EMAIL_TEMPLATE_DETAILS = '/email-template/{id}';
export const EMAIL_TEMPLATE_STATUS = '/email-template/{id}/status';
export const EMAIL_TEMPLATE_STATS = '/email-template/stats';

// PDF Display endpoints
export const PDF_DISPLAY_GENERATE = '/public/pdf-display/generate';